__turbopack_context__.v({
  "arrowUTF8": "HeroSectionHomeNew-module-scss-module__0ajGbq__arrowUTF8",
  "badge": "HeroSectionHomeNew-module-scss-module__0ajGbq__badge",
  "badgeIcon": "HeroSectionHomeNew-module-scss-module__0ajGbq__badgeIcon",
  "badgeRow": "HeroSectionHomeNew-module-scss-module__0ajGbq__badgeRow",
  "ctaPrimary": "HeroSectionHomeNew-module-scss-module__0ajGbq__ctaPrimary",
  "ctaRow": "HeroSectionHomeNew-module-scss-module__0ajGbq__ctaRow",
  "ctaSecondary": "HeroSectionHomeNew-module-scss-module__0ajGbq__ctaSecondary",
  "featureRow": "HeroSectionHomeNew-module-scss-module__0ajGbq__featureRow",
  "heroContainer": "HeroSectionHomeNew-module-scss-module__0ajGbq__heroContainer",
  "heroHeading": "HeroSectionHomeNew-module-scss-module__0ajGbq__heroHeading",
  "heroImage": "HeroSectionHomeNew-module-scss-module__0ajGbq__heroImage",
  "heroImageWrapper": "HeroSectionHomeNew-module-scss-module__0ajGbq__heroImageWrapper",
  "heroLeft": "HeroSectionHomeNew-module-scss-module__0ajGbq__heroLeft",
  "heroRight": "HeroSectionHomeNew-module-scss-module__0ajGbq__heroRight",
  "heroSection": "HeroSectionHomeNew-module-scss-module__0ajGbq__heroSection",
  "hidden": "HeroSectionHomeNew-module-scss-module__0ajGbq__hidden",
  "mid": "HeroSectionHomeNew-module-scss-module__0ajGbq__mid",
  "mobileCard": "HeroSectionHomeNew-module-scss-module__0ajGbq__mobileCard",
  "mobileHeroBackground": "HeroSectionHomeNew-module-scss-module__0ajGbq__mobileHeroBackground",
  "mobileHeroBackgroundImage": "HeroSectionHomeNew-module-scss-module__0ajGbq__mobileHeroBackgroundImage",
  "programCard": "HeroSectionHomeNew-module-scss-module__0ajGbq__programCard",
  "programCards": "HeroSectionHomeNew-module-scss-module__0ajGbq__programCards",
  "programImg": "HeroSectionHomeNew-module-scss-module__0ajGbq__programImg",
  "programImgWrapper": "HeroSectionHomeNew-module-scss-module__0ajGbq__programImgWrapper",
  "programSliderSlot": "HeroSectionHomeNew-module-scss-module__0ajGbq__programSliderSlot",
  "programSpec": "HeroSectionHomeNew-module-scss-module__0ajGbq__programSpec",
  "programTitle": "HeroSectionHomeNew-module-scss-module__0ajGbq__programTitle",
});
